module.exports = __webpack_public_path__ + "img/tarjeta_bg.5955798.png";